import { useState, useCallback, useEffect } from "react";

import { categories, topics, questions } from "../Data";

function useQuestions({
  category,
  topic,
  shuffleGroups,
  shuffleQuestions,
  modulus,
}) {
  const shuffle = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  const shuffledQuestions = useCallback(() => {
    return categories()
      .filter((c) => (category ? c === category : true))
      .sort((i) => (shuffleGroups ? 0.5 - Math.random() : null))
      .flatMap((c) =>
        topics(c)
          .filter((t) => (topic ? t === topic : true))
          .sort((i) => (shuffleGroups ? 0.5 - Math.random() : null))
          .flatMap((t) => {
            let q = Object.keys(questions(c, t));
            if (shuffleQuestions) {
              shuffle(q);
            }
            return q.filter((i, idx) => idx % modulus === 0);
          })
      );
  }, [category, topic, shuffleGroups, shuffleQuestions, modulus]);

  useEffect(() => {
    setRandomQuestions(shuffledQuestions());
  }, [shuffledQuestions]);

  const [randomQuestions, setRandomQuestions] = useState(() => {
    return shuffledQuestions();
  });

  return randomQuestions;
}

export default useQuestions;
